import React from "react";
import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";

export const TaxheadCreate = (props) => {
  return (
    <Create title="Taxhead Create" {...props}>
      <SimpleForm
        redirect="list"
        toolbar={<FormToolbar {...props} showDelete={false} />}
        variant="outlined"
      >
      
        <TextInput source="taxCode" label="Tax Code"   fullWidth={true} validate={[required()]} />
        <TextInput source="taxName" label="Tax Name"   fullWidth={true} validate={[required()]} />
        <NumberInput  source="taxpc" label="Tax %"  fullWidth={true} validate={[required()]} />
        <BooleanInput source="isActive" validate={[required()]} label="Active" initialValue={true}/>
        
        
      </SimpleForm>
    </Create>
  );
};
